// Career + travel timeline data.
//
// `kind`: 'dev' (career/education), 'travel' (journey, Traveler Mode only),
// or 'both' (shared origin events shown on the center lane in Traveler Mode).
// `sortKey` merges the two stories chronologically. In engineer mode the
// travel events stay hidden and the ut-grad card keeps its footnote list of
// adventures; in Traveler Mode the footnotes give way to full travel cards.
const TIMELINE_EVENTS = [
  {
    id: 'birth',
    kind: 'both',
    sortKey: '1998-02',
    image: 'images/profile_pictures/born.png',
    period: { ja: '1998年2月15日', en: 'Feb 15, 1998' },
    title: { ja: '奈良県に生まれる', en: 'Born in Nara, Japan' },
    notes: {
      ja: ['実家は法隆寺から徒歩30秒！'],
      en: ['My family home is about 30 seconds on foot from Horyu-ji Temple.'],
    },
    travels: [],
  },
  {
    id: 'high-school',
    kind: 'dev',
    sortKey: '2010-04',
    image: 'images/profile_pictures/nwvk_1.jpg',
    period: { ja: '2010年4月 - 2016年3月', en: 'Apr 2010 - Mar 2016' },
    title: {
      ja: '私立灘中学校・高等学校（卒業）',
      en: 'Nada Junior & Senior High School [Graduated]',
    },
    notes: {
      ja: ['ワンダーフォーゲル部（登山部）の部長として、毎週のように山に登っていました。'],
      en: ['As captain of the mountaineering club, I was hiking almost every weekend.'],
    },
    travels: [],
  },
  {
    id: 'trip-shikoku',
    kind: 'travel',
    sortKey: '2012-08',
    vehicle: 'bicycle',
    tripRef: 'shikoku-cycling',
    image: '',
    period: { ja: '2012年夏（中3）', en: 'Summer 2012 (age 14)' },
    title: { ja: '自転車で四国一周', en: 'Around Shikoku by bicycle' },
    notes: {
      ja: ['友達2人とテントを積んで7泊8日。すべての旅の原点。'],
      en: ['Eight days with two friends and a tent — where every journey began.'],
    },
    travels: [],
  },
  {
    id: 'trip-tokyo',
    kind: 'travel',
    sortKey: '2016-03',
    vehicle: 'bicycle',
    tripRef: 'tokyo-cycling',
    image: 'images/travels/tokyo-cycling/6.jpg',
    period: { ja: '2016年3月末', en: 'Late Mar 2016' },
    title: { ja: '自転車で上京', en: 'To Tokyo by bicycle' },
    notes: {
      ja: ['奈良の実家から下北沢の新居まで、4泊5日。'],
      en: ['Ikaruga to Shimokitazawa in five days, by bicycle.'],
    },
    travels: [],
  },
  {
    id: 'ut-entry',
    kind: 'dev',
    sortKey: '2016-04',
    image: 'images/profile_pictures/uni_1.jpg',
    period: { ja: '2016年4月 - 2018年3月', en: 'Apr 2016 - Mar 2018' },
    title: { ja: '東京大学 理科II類', en: 'University of Tokyo, Science II' },
    notes: {
      ja: ['解剖や化学実験の細かい作業が苦手で、実験のない経済学部に進学しました（笑）'],
      en: [
        'I found detailed lab work in anatomy and chemistry challenging, so I moved to Economics, where there were no lab courses.',
      ],
    },
    travels: [],
  },
  {
    id: 'trip-nz',
    kind: 'travel',
    sortKey: '2017-02',
    vehicle: 'bicycle',
    tripRef: 'nz-cycling',
    image: 'images/travels/nz-cycling/10.jpg',
    period: { ja: '2017年2月〜3月', en: 'Feb–Mar 2017' },
    title: { ja: '自転車でニュージーランド南島縦断', en: 'NZ South Island by bicycle' },
    notes: {
      ja: ['約40日。ウェリントンから南島最南端まで。'],
      en: ['About 40 days, Wellington to the southern tip.'],
    },
    travels: [],
  },
  {
    id: 'trip-hitchhike',
    kind: 'travel',
    sortKey: '2017-11',
    vehicle: 'thumb',
    tripRef: 'japan-hitchhike',
    image: 'images/travels/japan-hitchhike/10.jpg',
    period: { ja: '2017年11月', en: 'Nov 2017' },
    title: { ja: 'ヒッチハイクで日本縦断', en: 'Hitchhiking the length of Japan' },
    notes: {
      ja: ['鹿児島から札幌へ、およそ50台を乗り継いで。'],
      en: ['Kagoshima to Sapporo, roughly fifty rides.'],
    },
    travels: [],
  },
  {
    id: 'ut-grad',
    kind: 'dev',
    sortKey: '2018-04',
    image: 'images/profile_pictures/uni_tuktuk.jpg',
    period: { ja: '2018年4月 - 2020年3月', en: 'Apr 2018 - Mar 2020' },
    title: {
      ja: '東京大学 経済学部金融学科（卒業）',
      en: 'UTokyo, Faculty of Economics (Finance) [Graduated]',
    },
    notes: {
      ja: ['在学中はDIVIC Corp.（プログラミングスクール）でJavaScript / Ruby on Railsメンターのインターンを経験。'],
      en: ['During university, I worked as a JavaScript and Ruby on Rails mentor at DIVIC Corp.'],
    },
    travels: [
      { ja: '自転車でニュージーランド南島を縦断', en: 'Cycled the length of New Zealand’s South Island' },
      { ja: 'バイクでベトナムを縦断', en: 'Crossed Vietnam by motorbike' },
      { ja: 'ヒッチハイクで日本を縦断', en: 'Hitchhiked the length of Japan' },
      { ja: 'トゥクトゥクでスリランカを一周', en: 'Looped Sri Lanka in a tuk-tuk' },
      { ja: '飛行機を使わずイスタンブールへ', en: 'Reached Istanbul without flying' },
    ],
    travelsClose: {
      ja: 'などなど、達成感のある冒険に没頭していました。',
      en: '…and other adventures I threw myself into for the sheer sense of accomplishment.',
    },
  },
  {
    id: 'trip-vietnam',
    kind: 'travel',
    sortKey: '2018-09',
    vehicle: 'motorbike',
    tripRef: 'vietnam-motorbike',
    image: 'images/travels/vietnam-motorbike/1.jpg',
    period: { ja: '2018年9月', en: 'Sep 2018' },
    title: { ja: 'バイクでベトナム縦断', en: 'Vietnam by motorbike' },
    notes: {
      ja: ['ハノイ→ホーチミン、国道1号線を約10日。'],
      en: ['Hanoi to Ho Chi Minh City down Highway 1 in ~10 days.'],
    },
    travels: [],
  },
  {
    id: 'trip-srilanka',
    kind: 'travel',
    sortKey: '2019-01',
    vehicle: 'tuktuk',
    tripRef: 'srilanka-tuktuk',
    image: 'images/travels/srilanka-tuktuk/2.jpg',
    period: { ja: '2019年1月〜2月', en: 'Jan–Feb 2019' },
    title: { ja: 'トゥクトゥクでスリランカ一周', en: 'Around Sri Lanka by tuk-tuk' },
    notes: {
      ja: ['自分で運転して島をぐるり。夜道では象と間一髪。'],
      en: ['Driving it myself, all the way around — one near miss with an elephant.'],
    },
    travels: [],
  },
  {
    id: 'trip-turkey',
    kind: 'travel',
    sortKey: '2019-08',
    vehicle: 'train',
    tripRef: 'no-fly-turkey',
    image: 'images/travels/no-fly-turkey/10.jpg',
    period: { ja: '2019年夏', en: 'Summer 2019' },
    title: { ja: '飛行機を使わずイスタンブールへ', en: 'To Istanbul without flying' },
    notes: {
      ja: ['船と鉄道を乗り継いで25日間のユーラシア横断。'],
      en: ['25 days across Eurasia by ferry, rail and cargo ship.'],
    },
    travels: [],
  },
  {
    id: 'grad-school',
    kind: 'dev',
    sortKey: '2020-04',
    image: 'images/profile_pictures/uni_grad.jpg',
    period: { ja: '2020年4月 - 2021年3月', en: 'Apr 2020 - Mar 2021' },
    title: {
      ja: '東京大学大学院 経済学研究科 マネジメント専攻 修士（経営学）（短縮修了）',
      en: 'UTokyo Graduate School of Economics, Management Major, Master of Management [Accelerated Completion]',
    },
    notes: {
      ja: ['ワーケーションの研究（フィールドワーク）として、各地でインタビューや実地調査を行いました。'],
      en: ['For my workation field research, I conducted interviews and on-site investigations across Japan.'],
    },
    travels: [
      { ja: 'スーパーカブで日本中を巡り、フィールドワークを実施', en: 'Rode a Super Cub across Japan for field research' },
    ],
  },
  {
    id: 'trip-hokkaido',
    kind: 'travel',
    sortKey: '2020-06',
    vehicle: 'cub',
    tripRef: 'hokkaido-cub',
    image: 'images/travels/hokkaido-cub/5.jpg',
    period: { ja: '2020年6月〜8月', en: 'Jun–Aug 2020' },
    title: { ja: 'スーパーカブで北海道一周', en: 'Around Hokkaido on a Super Cub' },
    notes: {
      ja: ['道内の日本百名山をすべて登頂しながらのワーケーション実践。'],
      en: ['Workation in practice — climbing all of Hokkaido’s 100 Famous Mountains en route.'],
    },
    travels: [],
  },
  {
    id: 'trip-kyushu',
    kind: 'travel',
    sortKey: '2021-02',
    vehicle: 'cub',
    tripRef: 'kyushu-okinawa-cub',
    image: 'images/travels/kyushu-okinawa-cub/2.jpg',
    period: { ja: '2021年2月〜3月', en: 'Feb–Mar 2021' },
    title: { ja: 'スーパーカブで九州・沖縄一周', en: 'Kyushu & Okinawa on a Super Cub' },
    notes: {
      ja: ['九州の百名山を全登頂。沖縄では「ゆんたく」の輪へ。'],
      en: ['All of Kyushu’s 100 Famous Mountains, then Okinawa’s yuntaku circles.'],
    },
    travels: [],
  },
  {
    id: 'cybozu',
    kind: 'dev',
    sortKey: '2021-04',
    image: 'images/profile_pictures/cybozu.jpg',
    period: { ja: '2021年4月 - 2023年5月', en: 'Apr 2021 - May 2023' },
    title: {
      ja: 'サイボウズ株式会社 ソリューション営業部',
      en: 'Cybozu Inc., Solution Sales Division',
    },
    notes: {
      ja: [
        '2年間でのべ約150社へのkintone導入提案を実施。',
        '顧客要件の整理、APIを利用したデモ設定、開発側への改修依頼まで一気通貫で担当。',
      ],
      en: [
        'Proposed kintone solutions to around 150 companies over two years.',
        'Handled discovery, API-based demos, and product feedback requests to engineers end-to-end.',
      ],
    },
    travels: [],
  },
  {
    id: 'trip-southamerica',
    kind: 'travel',
    sortKey: '2023-05',
    vehicle: 'backpack',
    tripRef: 'south-america',
    image: 'images/travels/south-america/1.jpg',
    period: { ja: '2023年5月〜6月', en: 'May–Jun 2023' },
    title: { ja: '南米周遊', en: 'South America overland' },
    notes: {
      ja: ['退職から留学まで。ウユニ、イグアス、マチュピチュ。'],
      en: ['Between jobs and school: Uyuni, Iguazú, Machu Picchu.'],
    },
    travels: [],
  },
  {
    id: 'bcit',
    kind: 'dev',
    sortKey: '2023-09',
    image: 'images/profile_pictures/bcit_grad.jpg',
    period: { ja: '2023年9月 - 2025年6月', en: 'Sep 2023 - Jun 2025' },
    title: {
      ja: 'ブリティッシュコロンビア工科大学（BCIT） コンピューターサイエンス / 予測分析専攻（卒業）',
      en: 'British Columbia Institute of Technology (BCIT), Computer Science / Predictive Analytics [Graduated]',
    },
    notes: {
      ja: [
        '作る方が楽しいと確信し、エンジニアとして成長するためにカナダへ2年間留学。',
        'クラスの約1/3が序盤で離脱するほどの厳しい環境で、仲間と毎日夜遅くまで学習する、まさに「修行」の日々でした。',
      ],
      en: [
        'Moved to Canada for two years to fully commit to becoming an engineer.',
        'It was an intense environment where about one-third of the class dropped out early, and my classmates and I studied late every night in what truly felt like disciplined training.',
      ],
    },
    travels: [],
  },
  {
    id: 'trip-uswest',
    kind: 'travel',
    sortKey: '2023-12',
    vehicle: 'campervan',
    tripRef: 'us-west-coast',
    image: 'images/travels/us-west-coast/1.jpg',
    period: { ja: '2023年12月〜2024年1月', en: 'Dec 2023 – Jan 2024' },
    title: { ja: 'キャンピングカーでアメリカ西海岸縦断', en: 'US West Coast by campervan' },
    notes: {
      ja: ['妻とふたり、ロサンゼルスからシアトルへ。'],
      en: ['With my wife, Los Angeles to Seattle.'],
    },
    travels: [],
  },
  {
    id: 'field-and-mountain',
    kind: 'dev',
    sortKey: '2024-06',
    image: 'images/profile_pictures/field_mountain.png',
    period: { ja: '2024年6月 - 現在', en: 'Jun 2024 - Present' },
    title: {
      ja: '株式会社フィールド＆マウンテン（フリーランスエンジニア）',
      en: 'Field & Mountain Co., Freelance Engineer',
    },
    notes: {
      ja: [
        'BCIT在学中に中高の先輩である山田淳さんに誘っていただき、フリーランス活動を開始。',
        '主にyamacomi（登山用品のクチコミサイト）の開発・運用や、登山ツアーの在庫管理システムの開発に携わっています。',
      ],
      en: [
        'Started freelance engineering work while at BCIT after an invitation from Jun Yamada, my senior from school.',
        'I mainly work on development and operations for yamacomi (a hiking gear review platform), as well as development of an inventory management system for mountaineering tours.',
      ],
    },
    travels: [],
  },
  {
    id: 'trip-bali',
    kind: 'travel',
    sortKey: '2024-07',
    vehicle: 'train',
    tripRef: 'no-fly-bali',
    image: 'images/travels/no-fly-bali/7.jpg',
    period: { ja: '2024年7月〜8月', en: 'Jul–Aug 2024' },
    title: { ja: 'マレーシア〜シンガポール〜インドネシア旅', en: 'Malaysia, Singapore & Indonesia' },
    notes: {
      ja: ['マレーシアからインドネシアまで、列車と船で約5週間。'],
      en: ['About five weeks from Malaysia to Indonesia by rail and sea.'],
    },
    travels: [],
  },
  {
    id: 'trip-taiwan',
    kind: 'travel',
    sortKey: '2025-08',
    vehicle: 'train',
    tripRef: 'taiwan-loop',
    image: 'images/travels/taiwan-loop/1.jpg',
    period: { ja: '2025年8月', en: 'Aug 2025' },
    title: { ja: '鉄道で台湾一周', en: 'Around Taiwan by rail' },
    notes: {
      ja: ['妻とふたり、台北から時計回りに8日間。'],
      en: ['With my wife, eight days clockwise from Taipei.'],
    },
    travels: [],
  },
  {
    id: 'gennai-sakura',
    kind: 'dev',
    sortKey: '2026-05',
    period: { ja: '2026年5月 - 2026年10月', en: 'May 2026 - Oct 2026' },
    title: {
      ja: 'E社 — 政府AI「源内」の国産クラウド移行プロジェクト',
      en: 'Company E — Moving the government AI "Gennai" to a Japanese cloud',
    },
    notes: {
      ja: [
        'デジタル庁が公開している「源内」は、官公庁や自治体の職員が使うための生成AIの基盤です（オープンソース）。もともとAWS（Amazonのクラウド）の上で動くように作られたこの仕組みを、さくらインターネットを中心とした国産クラウドへまるごと引っ越すプロジェクトを担当しました。',
        '設計から開発まで、プロジェクト全体をひとりで担当。「AWSで動いていたときと同じ機能・性能を保つ」「大元のソースコードへの手直しは最小限にとどめる」「今後のアップデートにも追従しやすくする」という、ときに相反する3つの難題をすべてクリアしました。',
        '5月の始動から10月末の完了まで約5ヶ月、そのうち実際の開発期間はわずか2ヶ月で、移行を成し遂げました。',
      ],
      en: [
        "Gennai is the open-source generative-AI platform that Japan's Digital Agency provides for national and local government staff. It was built to run on AWS (Amazon's cloud); I took on the project of moving the whole system onto Japanese cloud infrastructure centered on Sakura Internet.",
        'I carried the entire project on my own, from architecture design to development, and cleared three demanding and often competing goals: keep the same features and performance it had on AWS, keep changes to the original source code to a minimum, and keep it easy to follow future upstream updates.',
        'From kickoff in May to completion at the end of October took about five months, with only two months of actual development.',
      ],
    },
    collapseNotes: true,
    link: { href: '#writing', label: { ja: '寄稿した記事はこちら', en: 'Read the articles I wrote' } },
    travels: [],
  },
];

export default TIMELINE_EVENTS;
